import { Box, Drawer } from '@mui/material';
import Loading from 'components/common/Loading';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import teamDrawer from 'store/app/ui/drawers/team/action';
import employeesStatus from 'store/selectors/employeesStatus';
import useActions from 'utils/useActions';
import CloseButton from '../CloseButton';
import TeamForm from './Form';

const TeamDrawer = () => {
  const isOpen = useSelector(state => state.drawers.team.isOpen);
  const { isLoading } = useSelector(employeesStatus);
  const close = useActions(teamDrawer.close);
  return (
    <Drawer anchor="right" open={isOpen} onClose={close}>
      <Box
        sx={theme => ({
          display: 'flex',
          width: '100%',
          [theme.breakpoints.up('md')]: {
            width: 1000,
          },
          flex: 1,
        })}
      >
        <Box sx={{ pt: '20px', pl: '20px' }}>
          <CloseButton onClick={close} />
        </Box>
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
            }}
          >
            <Loading />
          </Box>
        ) : (
          <TeamForm />
        )}
      </Box>
    </Drawer>
  );
};

export default memo(TeamDrawer);
